import { SaveButton } from '@lib/core/src';
import palette from '@lib/core/src/theme/palette';
import { Box, Stack, Typography } from '@mui/material';

import { MeetingTemplateDtoProvider } from '@/api/generated';
import HubspotLogo from '@/assets/third-party-logos/hubspot/hubspot.svg?react';

import {
  IntegrationBoxContainer,
  IntegrationCard,
  TemplateConfigItemsTitle
} from './AgentTemplateStyles';

export const AgentTemplateIntegrationSection: React.FC<{
  isIntegratedWithHubSpot: boolean;
  provider?: MeetingTemplateDtoProvider;
  setProvider: React.Dispatch<React.SetStateAction<MeetingTemplateDtoProvider | undefined>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ setOpen, isIntegratedWithHubSpot, provider, setProvider }) => (
  <Box>
    <Typography sx={{ color: palette.black, fontSize: '13px', fontWeight: 500 }}>
      Integrate meeting summary
    </Typography>
    <TemplateConfigItemsTitle>
      Suggest updating the provider when meetings with these titles are detected.
    </TemplateConfigItemsTitle>
    <Box>
      {!isIntegratedWithHubSpot ? (
        <IntegrationBoxContainer>
          <Box sx={{ marginLeft: '12px' }}>
            <Typography sx={{ color: palette.black, fontSize: '12px', fontWeight: 500 }}>
              Integrate Your Workflow
            </Typography>
            <Typography sx={{ color: palette.grey[500], fontSize: '11px', fontWeight: 500 }}>
              Sync with your go-to platforms
            </Typography>
          </Box>
          <SaveButton
            sx={{ height: '28px', width: 'auto', padding: '8px 12px', marginRight: '25px' }}
            onClick={() => setOpen(true)}
          >
            Connect
          </SaveButton>
        </IntegrationBoxContainer>
      ) : (
        <Stack flexDirection={'row'} gap={'6px'}>
          <IntegrationCard onClick={() => setProvider(undefined)} isIntegrate={!provider}>
            <Typography sx={{ fontSize: '12px' }}>None</Typography>
          </IntegrationCard>
          <IntegrationCard
            onClick={() => setProvider(MeetingTemplateDtoProvider.hubspot)}
            isIntegrate={provider === MeetingTemplateDtoProvider.hubspot}
          >
            <Stack flexDirection={'row'} gap={'6px'} alignItems={'center'}>
              <HubspotLogo height={20} width={20} />{' '}
              <Typography sx={{ fontSize: '12px' }}>Hubspot</Typography>
            </Stack>
          </IntegrationCard>
        </Stack>
      )}
    </Box>
  </Box>
);
